const TakeAllContestsFromAllResults = function (AllContestResult,GETContestName,GETContestDate) {// Все конкурсы вида название-дата, а также из гет-запроса мы получаем данные обо всех конкурсах в
    const AllContestDays = {};
    let ActiveContestID = '';
    const date = new Date();
    let ActiveContestYear = date.getFullYear();
        // console.log('5555555555',AllContestResult);
    try{
        AllContestResult.forEach(// Пишем запись по годам в AllContestDays - формат {year:[{ContestDate: дата,ContestName: имя, _id: уникальный_номер, active: активность}]}
            function (Contest) {
                let year = Contest.ContestDate.slice(0,4); // Год мы берем просто как первые 4 знака у даты.
                if (!AllContestDays[year]) {AllContestDays[year] = {}} // Элемент года - объект ID конкурса : данные по конкурсу
                let ActiveContest = false;
                if (GETContestName === Contest.ContestName.split('---')[0] && GETContestDate === Contest.ContestDate) {
                    ActiveContest = true;
                    ActiveContestID = Contest._id;
                    ActiveContestYear = +Contest.ContestDate.slice(0,4)
                } // Выделяем активный конкурс из гет-запроса
                // console.log('Проверяем - ',GETContestName,Contest.ContestName.split('---')[0],GETContestDate,Contest.ContestDate)
                AllContestDays[year][Contest._id] = {ContestDate : Contest.ContestDate.slice(5),ContestName: Contest.ContestName, ContestDateID : Contest._id, active: ActiveContest};
            }
        );
        if (!(GETContestName && GETContestDate)) {// Только чтобы текущий год взять и первый элемент текущего года сделать активным конкурсом
            ActiveContestID = AllContestResult[0]._id; // Мы берем из первоначального массива AllContestResult а не получившегося объекта - просто первый элемент
            ActiveContestYear = +AllContestResult[0].ContestDate.slice(0,4); // год первого элемента
            (AllContestDays[ActiveContestYear])[ActiveContestID].active = true;} // Чтобы первый элемент был true если у нас нет гет-запроса. Это мы меняем объект
    }  catch(error) {console.error(error);}
    return [AllContestDays,ActiveContestID,ActiveContestYear];
}

module.exports.TakeAllContestsFromAllResults = TakeAllContestsFromAllResults;